<script>
export default {
  name: 'TeacherListItemsLike',
  data () {
    return {
      name: 'favorite_border',
      color: 'color_icon',
      isLiked: false
    }
  },
  watch: {
    isLiked (val) {
      if (val) {
        this.name = 'favorite'
        this.color = 'error'
      } else {
        this.name = 'favorite_border'
        this.color = 'color_icon'
      }
    }
  },
  methods: {
    clicked () {
      this.isLiked = !this.isLiked
    },
    mouseOver () {
      this.name = 'favorite'
      this.color = 'error'
    },
    mouseLeave () {
      if (!this.isLiked) {
        this.name = 'favorite_border'
        this.color = 'color-icon'
      }
    }
  }
}
</script>

<template>
  <div
    class="list-items-like"
    @click="clicked"
  >
    <BaseIcon
      class="cursor-pointer"
      :name="name"
      :color="color"
      size="sm-md"
      @mouseover="mouseOver"
      @mouseleave="mouseLeave"
    />
  </div>
</template>

<style scoped lang="scss">
.list-items-like {
  @apply flex justify-start items-center;
}
</style>
